import { WorkloadType } from '@/components/Workload/types';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { getControllerreVisions, getReplicasets } from '../api';
import { WorkloadFetch } from '../constants';

const { DEPLOYMENT } = WorkloadType;

interface UseReplicasetsOptions {
  cluster: string;
  namespace: string;
  labelSelector: string | null;
}

/** 获取修改记录 */
export const useReplicasets = (
  module: WorkloadType,
  { cluster, namespace, labelSelector }: UseReplicasetsOptions,
) => {
  const [items, setItems] = useState([]);
  const swrKey = { key: WorkloadFetch.REPLICASETS, module, cluster, namespace, labelSelector };

  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(
    labelSelector ? swrKey : null,
    async ({ module, cluster, namespace, labelSelector }) => {
      if (module === DEPLOYMENT) {
        return getReplicasets({ cluster, namespace, labelSelector });
      }
      return getControllerreVisions({ cluster, namespace, labelSelector });
    },
  );

  useEffect(() => {
    if (response) {
      const res = get(response, 'items', []);
      const getTimestamp = (item: any) => {
        const ts = get(item, 'metadata.creationTimestamp', '');
        const parsed = Date.parse(ts);
        return Number.isNaN(parsed) ? 0 : parsed;
      };
      // 按照 metadata.creationTimestamp 升序排序
      const sortedItems = res.sort((a, b) => getTimestamp(a) - getTimestamp(b));
      setItems(sortedItems);
    }
  }, [response]);

  return {
    items,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
